import React, { FunctionComponent, useEffect, useState } from 'react';
import { Card, Col, Collapse, Form, Input, notification, Row, Spin, Tooltip } from 'antd';

import { IAppComponentProps } from '../../components';
import client from '../../config/GraphQLApolloClient';
import { QUERY_SURVEY_GOLIVE } from './queries';
import { useIntl } from 'react-intl';
import { getGroupId } from '../../utils';
import { getGoLiveDates_getGoLiveDates } from './__generated__/getGoLiveDates';
import { StateContainer } from './utilities/StateContainer';
import { convertFromSpecifiedDateFormatToUserDefined } from '../users/UserFormatPreferenceServices';
import { Link } from 'react-router-dom';
import { getI18n } from '../../utils/Utils';
import { HomeOutlined } from '@ant-design/icons';
import Paragraph from "antd/lib/typography/Paragraph";
import styling from './styling/survey.module.css';

type ISurveyGoLiveStepProps = {
    prev?: any;
    stateContainer?: StateContainer;
} & IAppComponentProps;

const SurveyGoLiveStep: FunctionComponent<ISurveyGoLiveStepProps> = (props) => {
    const intl = useIntl();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(undefined);
    const [goLiveData, setGoLiveData] = useState<getGoLiveDates_getGoLiveDates>(undefined);

    useEffect(() => {
        const groupId = getGroupId();
        if (goLiveData === undefined) {
            setLoading(true);
            client
                .query({
                    query: QUERY_SURVEY_GOLIVE,
                    variables: { groupId },
                    fetchPolicy: 'network-only',
                })
                .then((response) => {
                    // eslint-disable-next-line no-console
                    console.dir(response.data.getGoLiveDates);
                    setGoLiveData(response.data.getGoLiveDates);
                    const formData = { ...response.data.getGoLiveDates };
                    if (response.data.getGoLiveDates) {
                        if (response.data.getGoLiveDates?.submissionDate?.length > 10) {
                            formData.submissionDate = `${convertFromSpecifiedDateFormatToUserDefined(
                                props.currentUser,
                                response.data.getGoLiveDates.submissionDate.substring(0, 10),
                                'YYYY-MM-DD'
                            )} ${response.data.getGoLiveDates.submissionDate.substring(10)}`;
                        }
                        if (response.data.getGoLiveDates?.confirmedGoLiveDate?.length > 10) {
                            formData.confirmedGoLiveDate = `${convertFromSpecifiedDateFormatToUserDefined(
                                props.currentUser,
                                response.data.getGoLiveDates.confirmedGoLiveDate.substring(0, 10),
                                'YYYY-MM-DD'
                            )} ${response.data.getGoLiveDates.confirmedGoLiveDate.substring(10)}`;
                        }
                    }

                    form.setFieldsValue(formData);
                    setLoading(false);
                })
                .catch((err) => {
                    notification.error(err);
                    setLoading(false);
                });
        }
    }, [goLiveData]);

    return (
        <>
            <Card title={
                <>
                    <span style={{ marginRight: '20px', marginTop: '20px' }}>
                    <Link to={'/survey/survey-overview'}>
                        <Tooltip
                            title={getI18n(
                                'survey-master-data-partner-tab-back-icon-tool-tip',
                                'Return to Survey Overview Page',
                                intl
                            )}
                            key={'keyCancelInvoiceIcon'}
                        >
                            <HomeOutlined
                                style={{ fontSize: '25px', cursor: 'pointer', color: '#024051', marginTop: '15px' }}
                            />
                        </Tooltip>
                    </Link>
                </span>
                    <span>{intl.formatMessage({id:'survey-main-wizard-go-live-title'})}</span>
                </>
            } size={'small'} className={`ml-10 ${styling.removeUnderLine}`}>

                <h3>{intl.formatMessage({ id: 'Welcome-title' })}</h3>

                <Collapse style={{marginBottom:"10px"}}>
                    <Collapse.Panel key='1' header={getI18n('Show-Description', 'Show Description', intl)} >

                        <Row>
                            <Col>
                                <Paragraph type={"secondary"}>GroupId: {getGroupId()}</Paragraph>
                            </Col>
                        </Row>
                {intl
                    .formatMessage({ id: 'go-live-service-provider-contact' })
                    .split('\\n')
                    .map((item, i) => (
                        <Paragraph key={i}>
                            {item}
                        </Paragraph>
                    ))}
                    </Collapse.Panel>
                </Collapse>
                <Spin spinning={loading} size={'large'}>
                    <Row gutter={8}>
                        <Col span={8}>
                            <Form
                                form={form}
                                name="basic"
                                labelCol={{ span: 10 }}
                                wrapperCol={{ span: 16 }}
                                labelAlign={'left'}
                                labelWrap={true}
                                initialValues={{ remember: true }}
                                onFinish={() => {}}
                                onFinishFailed={() => {}}
                            >
                                <Form.Item
                                    label={intl.formatMessage({
                                        id: 'goLive-submissionDate-col',
                                        defaultMessage: 'Your submission date is',
                                    })}
                                    name="submissionDate"
                                >
                                    <Input readOnly={true} type="text" />
                                </Form.Item>
                                <Form.Item
                                    label={intl.formatMessage({
                                        id: 'goLive-confirmedGoLiveDate-col',
                                        defaultMessage: 'Your confirmed go-live date is',
                                    })}
                                    name="confirmedGoLiveDate"
                                >
                                    <Input readOnly={true} type="Text" />
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                </Spin>
            </Card>
        </>
    );
};

export default SurveyGoLiveStep;
